import {ProductionState} from './types';

export const initialState: ProductionState = {
  latestCreatedFamily: undefined,
};
